import {
  Flex, HStack, Icon, IconButton, Text, Tooltip,
} from '@chakra-ui/react';
import { FaSyncAlt } from 'react-icons/fa';
import ColorPicker from '../ColorPicker/ColorPicker';

const ColorField = ({
  label = 'Color',
  color,
  onChange,
  tooltipLabel = 'Reset',
}) => (
  <Flex justify="space-between" w="100%" alignItems="center">
    <Text>{label}</Text>
    <HStack>
      <ColorPicker
        color={color}
        onChange={(c) => onChange(c)}
      />
      <Tooltip label={tooltipLabel}>
        <IconButton icon={<Icon as={FaSyncAlt} />} size="xs" onClick={() => onChange('')} />
      </Tooltip>
    </HStack>
  </Flex>
);

export default ColorField;
